import { useEffect } from "react";

/**
 * Redirect del browser verso un dominio esterno.
 * Usato per instradare le vecchie rotte pubbliche (/noleggio, /checkout, /prenota)
 * al sito ufficiale https://fabri-rent.it dove avviene oggi la prenotazione.
 */
export default function ExternalRedirect({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        background: "#050505",
        color: "#fff",
        fontFamily: "system-ui, sans-serif",
      }}
      data-testid="external-redirect"
    >
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: 14, opacity: 0.6, marginBottom: 10 }}>
          Ti stiamo reindirizzando…
        </div>
        <a href={to} style={{ color: "#ff0033", textDecoration: "none" }}>
          Vai su {to}
        </a>
      </div>
    </div>
  );
}
